import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function Trash2($$anchor, $$props) {
	const iconNode = [
		["path", { "d": "M10 11v6" }],
		["path", { "d": "M14 11v6" }],
		["path", { "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }],
		["path", { "d": "M3 6h18" }],
		["path", { "d": "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiVHJhc2gyLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiPlxuICBpbXBvcnQgSWNvbiBmcm9tICcuL0ljb24uc3ZlbHRlJztcbiAgY29uc3QgaWNvbk5vZGU6IFtzdHJpbmcsIFJlY29yZDxzdHJpbmcsIHN0cmluZz5dW10gPSBbW1wicGF0aFwiLCB7IFwiZFwiOiBcIk0xMCAxMXY2XCIgfV0sIFtcInBhdGhcIiwgeyBcImRcIjogXCJNMTQgMTF2NlwiIH1dLCBbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTE5IDZ2MTRhMiAyIDAgMCAxLTIgMkg3YTIgMiAwIDAgMS0yLTJWNlwiIH1dLCBbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTMgNmgxOFwiIH1dLCBbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTggNlY0YTIgMiAwIDAgMSAyLTJoNGEyIDIgMCAwIDEgMiAydjJcIiB9XV07XG4gIGxldCByZXN0ID0gJHByb3BzKCk7XG48L3NjcmlwdD5cbjxJY29uIHtpY29uTm9kZX0gey4uLnJlc3R9IC8+XG4iXSwibWFwcGluZ3MiOiI7O09BQ1MsSUFBSSxNQUFNLGVBQWU7O2tEQURsQyxDQUFDO09BRU8sUUFBNEM7R0FBSyxNQUFNLElBQUksR0FBRyxFQUFFLFVBQVU7R0FBTSxNQUFNLElBQUksR0FBRyxFQUFFLFVBQVU7R0FBTSxNQUFNLElBQUksR0FBRyxFQUFFLDBDQUEwQztHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsU0FBUztHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsd0NBQXdDOzs7S0FDclEsSUFBSTs7Ozs7Ozs7UUFFVyxJQUFJOztBQUQxQixDQUFDIn0=